import { render, staticRenderFns } from "./materialAccountDetail.vue?vue&type=template&id=047352b2&scoped=true"
import script from "./materialAccountDetail.vue?vue&type=script&lang=js"
export * from "./materialAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./materialAccountDetail.vue?vue&type=style&index=0&id=047352b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047352b2",
  null
  
)

export default component.exports